import { render, staticRenderFns } from "./fatigue_rule.vue?vue&type=template&id=5d50507d&"
import script from "./fatigue_rule.vue?vue&type=script&lang=js&"
export * from "./fatigue_rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports